import { CategoryActions, SaveCategories } from './category.actions';
import { MessageActions } from './message.actions';
import { CategoryFormActions } from './category-form.actions';
import { TicketQuotaActions } from './ticket-quota.actions';
import { PriceLevelActions } from './pricelevel.actions';
import { RoutingActions } from './routing.actions';
import { EventsOnSaleActions } from "../components/events-on-sale";
import { CheckoutActions } from "../components/checkout-components/checkout.actions"
import { AppActions } from "./app.actions"
import { EventOverviewActions } from "./event-overview.actions"
import { EventActions } from "./event.actions"
import { SeatingplanServerActions } from "./seatingplan-server.actions"
import { EventCategoryActions } from "./event-category.actions"
import { VenueActions } from "../components/venue-components/venue.actions"
import { TicketDesignActions } from "../components/event-components/ticket-designs/ticket-design.actions"
import { AdditionalChargeActions, AdditionalChargesToSave } from "./additional-charge.actions";
import { TicketAddressActions } from "../components/checkout-components/ticket-address/reducer/ticket-address.actions"
import { KeepAppointmentActions } from "../components/keep-appointment";
import { BoxOfficeActions } from "../components/box-office/ngrx/box-office.actions"
import { ReportingActions } from "../components/reporting/reporting.actions";
import { SponsorActions } from "../components/sponsors/sponsor.actions";

export {
	CategoryActions, MessageActions, PriceLevelActions, SaveCategories, CategoryFormActions, TicketQuotaActions, RoutingActions, AppActions,
	EventOverviewActions, EventActions, VenueActions, CheckoutActions, TicketDesignActions, SeatingplanServerActions, EventCategoryActions,
	AdditionalChargeActions, AdditionalChargesToSave, TicketAddressActions, BoxOfficeActions, ReportingActions, SponsorActions
};

export const ACTION_PROVIDER =  [
	CategoryActions, MessageActions, PriceLevelActions, CategoryFormActions, TicketQuotaActions, RoutingActions, EventsOnSaleActions, AppActions,
	EventOverviewActions, EventActions, VenueActions, CheckoutActions, TicketDesignActions, SeatingplanServerActions, EventCategoryActions,
	AdditionalChargeActions, TicketAddressActions, KeepAppointmentActions, BoxOfficeActions, ReportingActions, SponsorActions
];



// WEBPACK FOOTER //
// ./src/app/actions/index.ts